import * as React from 'react';
import S from './ScrollLoader.styles';
import { ReactComponent as SvgLoader } from '@img/icons/loader.svg';
import { withMotion } from '@hoc/WithMotion';
import { useFirstMountState } from 'react-use';
const ScrollLoader = ({ loading, callback }) => {
    const isFirstMount = useFirstMountState();
    // loading begins as false, changes to true for the initial load, back to false when the initial load completes //
    // We want to only listen to changes *after* this series has happened //
    const [loadChangeCount, setLoadChangeCount] = React.useState(0);
    React.useEffect(() => {
        if (!loading && !isFirstMount) {
            setLoadChangeCount(loadChangeCount + 1);
        }
    }, [loading]);
    React.useEffect(() => {
        if (!loading && loadChangeCount >= 1 && callback) {
            callback();
        }
    }, [loading, loadChangeCount]);
    return (React.createElement(S.LoadingIndicator, { initial: "hidden", animate: loading ? 'visible' : 'hidden', variants: {
            hidden: {
                opacity: 0,
                transitionEnd: {
                    display: 'none',
                },
            },
            visible: {
                display: 'grid',
                opacity: 1,
            },
        } },
        React.createElement(SvgLoader, null)));
};
export default withMotion(ScrollLoader);
